import { ApiError } from './api-error';

export class UnauthorizedError extends ApiError {}
